module.exports = __webpack_public_path__ + "img/icon-ahorro.3f4bce67.svg";